import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Label, Input, PrimaryButton } from "@/components/fields";

export default function SecurityPanel() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (next !== confirm) {
      toast.error("New passwords don't match");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated — please sign in with your new password");
      await logout();
      navigate("/auth");
    } catch (e) {
      toast.error(formatApiError(e));
      setSaving(false);
    }
  };

  return (
    <div className="max-w-md" data-testid="admin-security-tab">
      <div className="rounded-2xl border border-ink/10 bg-white p-6 space-y-4">
        <div className="flex items-center gap-2 text-ink">
          <ShieldCheck size={18} className="text-terracotta" />
          <h2 className="font-semibold">Change password</h2>
        </div>
        <p className="text-sm text-ink/60">
          Set a new password for your owner account. You'll be signed out everywhere and can sign back in with the new password.
        </p>
        <div>
          <Label htmlFor="sec-current">Current password</Label>
          <Input id="sec-current" data-testid="security-current-password" type="password" autoComplete="current-password"
                 value={current} onChange={(e) => setCurrent(e.target.value)} />
        </div>
        <div>
          <Label htmlFor="sec-new">New password (min. 8 characters)</Label>
          <Input id="sec-new" data-testid="security-new-password" type="password" autoComplete="new-password"
                 value={next} onChange={(e) => setNext(e.target.value)} />
        </div>
        <div>
          <Label htmlFor="sec-confirm">Repeat new password</Label>
          <Input id="sec-confirm" data-testid="security-confirm-password" type="password" autoComplete="new-password"
                 value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </div>
        <PrimaryButton data-testid="security-save-btn" onClick={submit}
                       disabled={saving || !current || next.length < 8 || !confirm}>
          {saving ? "Updating…" : "Update password"}
        </PrimaryButton>
      </div>
    </div>
  );
}
